var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlaneTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.1702 7.70817L5.1389 18.9991C4.80212 19.0941 4.50236 19.2896 4.27968 19.5595C4.057 19.8294 3.92201 20.1608 3.89274 20.5095C3.86348 20.8582 3.94134 21.2075 4.11591 21.5108C4.29049 21.814 4.55347 22.0568 4.8697 22.2066L23.2627 30.919C23.6214 31.089 23.9102 31.3778 24.0802 31.7366L32.7926 50.1295C32.9424 50.4457 33.1852 50.7087 33.4884 50.8833C33.7917 51.0579 34.141 51.1357 34.4897 51.1065C34.8384 51.0772 35.1698 50.9422 35.4397 50.7195C35.7096 50.4968 35.9051 50.1971 36.0001 49.8603L47.291 9.82895C47.374 9.5349 47.377 9.22405 47.2999 8.92843C47.2227 8.6328 47.0682 8.36308 46.8522 8.14704C46.6361 7.931 46.3664 7.77646 46.0708 7.69932C45.7751 7.62218 45.4643 7.62523 45.1702 7.70817Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1702 7.70817L5.1389 18.9991C4.80212 19.0941 4.50236 19.2896 4.27968 19.5595C4.057 19.8294 3.92201 20.1608 3.89274 20.5095C3.86348 20.8582 3.94134 21.2075 4.11591 21.5108C4.29049 21.814 4.55347 22.0568 4.8697 22.2066L23.2627 30.919C23.6214 31.089 23.9102 31.3778 24.0802 31.7366L32.7926 50.1295C32.9424 50.4457 33.1852 50.7087 33.4884 50.8833C33.7917 51.0579 34.141 51.1357 34.4897 51.1065C34.8384 51.0772 35.1698 50.9422 35.4397 50.7195C35.7096 50.4968 35.9051 50.1971 36.0001 49.8603L47.291 9.82895C47.374 9.5349 47.377 9.22405 47.2999 8.92843C47.2227 8.6328 47.0682 8.36308 46.8522 8.14704C46.6361 7.931 46.3664 7.77646 46.0708 7.69932C45.7751 7.62218 45.4643 7.62523 45.1702 7.70817Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8164 31.1819L33.5391 21.4592",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTilt);
export default __webpack_public_path__ + "static/media/PaperPlaneTilt.1c62263e01342da350025b2ec1f7c968.svg";
export { ForwardRef as ReactComponent };